import { createAction } from 'typesafe-actions'

import { Prices } from '../types'

export const pricesUpdatedAction = createAction('@@prices/updated')<Prices>()
export const pricesInitAction = createAction('@@prices/init')<Prices>()
